import React from 'react';
import styled from 'styled-components';
import Flower from './Flower';

const GardenContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  padding: 2rem;
  max-width: 1600px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;

  @media (min-width: 1600px) {
    grid-template-columns: repeat(5, 1fr);
  }

  @media (max-width: 1400px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 2rem;
    justify-items: center;
    max-width: 400px;
  }
`;

const Garden = ({ stocks }) => {
  const isSearchResult = stocks.length === 1;

  return (
    <GardenContainer>
      {stocks.map((stock) => (
        <Flower
          key={stock.symbol}
          stock={stock}
          isSearchResult={isSearchResult}
        />
      ))}
    </GardenContainer>
  );
};

export default Garden; 